import { MenuItem } from '@/interfaces/menuItem'

export const menuItems: MenuItem[] = [
    {
        name: 'Mapa wykonawców',
        url: 'Home'
    },
    {
        name: 'Zostań Superwykonawcą!',
        url: 'SuperWykonawca'
    },
    {
        name: 'Aplikacja',
        url: 'Aplikacja'
    },
    {
        name: 'Program lojalnościowy',
        url: 'ProgramLojanosciowy'
    },
    {
        name: 'YouTube',
        url: 'Youtube'
    }
]
